import { inject, Pipe, PipeTransform } from '@angular/core';
import { defaultLocale } from '../lib/build-locale';
import { joinPath } from '../lib/join-path';
import { LanguageService } from '../services/language.service';

export const localeToPathPrefix = (locale: string): string => {
  if (locale === defaultLocale) return '';
  return locale.toLowerCase();
};

export const translateLink = (path: string[], locale: string): string[] => {
  if (locale.toLowerCase() === defaultLocale.toLowerCase()) {
    return path;
  }
  const prefix = localeToPathPrefix(locale);

  const cleanPath = path.map(p => p.replaceAll('/', '')).filter(Boolean);

  if (cleanPath[0] === prefix) {
    cleanPath.shift();
  }

  return ['/' + (prefix || ''), ...cleanPath];
};

@Pipe({
  name: 'translateLink',
  pure: false,
})
export class TranslateLinkPipe implements PipeTransform {
  private languageService = inject(LanguageService);

  transform(path: string[]): string {
    const locale = this.languageService.currentLocale();
    const cleanedPath = ['/', ...path.map(p => p.split('/').filter(Boolean)).flat()];
    return joinPath(translateLink(cleanedPath, locale));
  }
}
